import React from 'react';

const Mail = ({ color='currentColor', size=24 }: { color?: string, size?: number }) => {
  return <svg width={size * .8} height={size} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <title/>
    <g>
      <polyline fill="none" points="4 8.2 12 14.1 20 8.2" stroke={color} strokeLinecap="round"
                strokeLinejoin="round" strokeWidth="2"/>
      <rect fill="none" height="14" rx="2" ry="2" stroke={color} strokeLinecap="round" strokeLinejoin="round"
            strokeWidth="2" width="18" x="3" y="6.5"/>
    </g>
  </svg>;
};

export default Mail;
